<template>
  <div class="point-main">
    <div class="double-point" v-if="isShowDoublePoint">
      <div class="">
        <div class="point-icon">
          <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/point-iconPc.png" alt="">
        </div>
      </div>
      <div>双倍积分</div>
    </div>
    <div class="point-content">
      <div class="point-icon" v-if="!isPayPage">
        <img v-show="!isShowDoublePoint" src="https://resource.rcclchina.com.cn/wechatMiniProgram/point-iconPc.png" alt="">
      </div>
      <div class="pointAndIcon">
        <div class="point-text">
          当前积分预计赠送<span style="color: #006AB6">{{point}}积分</span>
        </div>
        <div class="point-questIcon" @mouseenter="showPointPopup" @mouseleave="hidePointPopup">
          <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/question.png" alt="">
        </div>
      </div>
      <div style="color: #5C5C5C" v-if="isPayPage && !isFinishSelfInfo" @click="goToEditInfo">
        请最晚于<span style="border-bottom: 1px solid #5C5C5C">下船日前</span>至会员中心<span style="color: #006AB6">完善信息</span>获取预订积分
      </div>
    </div>
    <div :class="!isPayPage ? 'point-popup' : 'point-popup-pay'" v-if="isShowPointPopup">
      <div v-if="!isPayPage" class="point-popup-content" style="margin-bottom: 10px">
        积分仅限皇家中国大陆官方网站、微信小程序、客服电话、飞猪旗舰店、抖音旗舰店预订可享。
      </div>
      <div class="point-popup-content">
        积分可<span>兑换限量皇家周边</span>，如定制行李箱、光谱号精美船模、各大视频会员等，还可参与<span>免费船票抽奖</span>~
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    point:{
      default: 0
    },
    isFinishSelfInfo:{
      type: Boolean,
      default: false
    },
    isPayPage:{
      type: Boolean,
      default: false
    },
    isShowDoublePoint:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShowPointPopup:false
    }
  },
  methods: {
    showPointPopup(){
      this.isShowPointPopup = true
    },
    hidePointPopup(){
      this.isShowPointPopup = false
    },
    goToEditInfo(){
      if(!this.isFinishSelfInfo){
        this.$router.push({
          path: '/Rccl.UserCenter/CustomerInfo/EditInfo'
        })
      }
    }
  }
}
</script>
<style scoped lang="less">
.point-main{
  position: relative;
  z-index: 9;
}
.double-point{
  display: flex;
  align-items: center;
  font-size: 12px;
  gap: 6px;
  & .point-icon{
    width: 16px;
    height: 16px;
    line-height: 1;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.point-content{
  display: flex;
  align-items: center;
  font-size: 12px;
  gap: 6px;
  cursor: pointer;
  .pointAndIcon{
    display: flex;
    align-items: center;
    gap: 6px;
    .point-text{
      width: 168px;
      text-align-last: justify;
    }
  }
  & .point-icon{
    width: 16px;
    height: 16px;
    line-height: 51px;
    img{
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  & .point-questIcon{
    width: 14px;
    height: 14px;
    line-height: 1;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.point-popup{
  width: 306px;
  height: 230px;
  background: url("https://resource.rcclchina.com.cn/wechatMiniProgram/point-popup-bg.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  padding: 76px 18px 29px;
  font-size: 14px;
  left: 49px;
  bottom: 20px;
  cursor: pointer;
  z-index: 99;
  line-height: 20px;
  box-shadow: 6px -10px 10px 0px rgba(0, 0, 0, 0.2);
  & .point-popup-content{
    color: #5C5C5C;
    & span{
      color: #006AB6;
    }
  }
}
.point-popup-pay{
  width: 218px;
  height: 183px;
  background: url("https://resource.rcclchina.com.cn/wechatMiniProgram/point-popup-bg.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  padding: 72px 17px 31px;
  font-size: 14px;
  left: 72px;
  bottom: 35px;
  cursor: pointer;
  z-index: 99;
  line-height: 20px;
  box-shadow: 6px -10px 10px 0px rgba(0, 0, 0, 0.2);
  & .point-popup-content{
    color: #5C5C5C;
    & span{
      color: #006AB6;
    }
  }
}
</style>
